import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RedirectService } from 'src/app/services/redirect.service';
import { MiscAdapter } from 'src/whiteLabel/mediaCorps/adapters/misc-adapter';

@Component({
  selector: 'redirect',
  templateUrl: './redirect.component.html'
})
export class RedirectComponent implements OnInit {

  constructor(
    private router: Router,
    private redirectService: RedirectService,
    private miscAdapter: MiscAdapter,) { }

  public ngOnInit() {
    const returnUrl = this.redirectService.getReturnUrl();
    if (returnUrl) {
      this.router.navigateByUrl(returnUrl);
    } else {
      this.miscAdapter.isMultiAdvertiser().then(((isMultiAdvertiser: boolean) => {
        if (!isMultiAdvertiser) {
          this.router.navigate(['campaign']);
        } else {
          this.router.navigate(['company']);
        }
      }));
    }
  }
}
